import type {ScorerDirectoryRecord} from "./scorer-directory-data";
export type CardCandidate={cardId:number;matchId:number;tournamentId:number;playerName:string;type:string;minute:number|null;sourceScorerIds:number[];participationIds:number[]};
export type AssignedCard<T extends CardCandidate=CardCandidate>=T&{recordId:number};
const nameKey=(s:string)=>s.trim().replace(/\s+/g," ").replace(/\s*\.\s*/g,". ").trim().toLocaleLowerCase("ru");
export function assignPlayerCards<T extends CardCandidate>(records:Pick<ScorerDirectoryRecord,"id"|"playerName"|"tournamentId">[],rows:T[]):AssignedCard<T>[]{
 const seen=new Set<number>();const out:AssignedCard<T>[]=[];
 for(const row of rows){
  if(seen.has(row.cardId)||!["yellow","red"].includes(row.type))continue;
  const candidates=records.filter(r=>r.tournamentId===row.tournamentId&&row.participationIds.includes(r.id));
  // An explicit imported source link is authoritative; never fall back to a surname match.
  const selected=candidates.filter(r=>row.sourceScorerIds.length?row.sourceScorerIds.includes(r.id):nameKey(r.playerName)===nameKey(row.playerName)).sort((a,b)=>a.id-b.id)[0];
  if(!selected)continue;seen.add(row.cardId);out.push({...row,recordId:selected.id});
 }
 return out;
}
export function playerCardTotals(cards:AssignedCard[],recordIds:number[]){
 const ids=new Set(recordIds);return cards.reduce((n,c)=>{if(ids.has(c.recordId)){if(c.type==="yellow")n.yellow++;if(c.type==="red")n.red++;}return n;},{yellow:0,red:0});
}
